var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFacebook = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m16.035 13.125.492-3.234h-3.129V7.78c0-.914.422-1.758 1.829-1.758h1.441V3.246S15.368 3 14.137 3C11.57 3 9.883 4.582 9.883 7.395V9.89H7v3.234h2.883V21h3.515v-7.875z"
})));
export default SvgFacebook;